module.exports = __webpack_public_path__ + "static/media/logo.ca84e9f2.svg";